

























import { Component, Vue } from 'vue-property-decorator';
import DepartmentNew from '@/components/Department/DepartmentNew.vue';

@Component({
  components: {
    DepartmentNew,
  },
})
export default class DepartmentNewButton extends Vue {
  public showDialog = false;
}
